import ReactDOM from 'react-dom/client';
import AppRoutes from './pages/route/router';

import { ServerEnvironment } from './components/serverEnvironment/server-environment-component';
import { AuthProvider } from 'data/context/auth-context';
import { Global } from 'pages/style/global/global-styled';
import { ReactNotifications } from 'react-notifications-component';
import 'react-notifications-component/dist/theme.css';
import { LoaderProvider } from './components/loader/loader-context';

import { init as initApm } from '@elastic/apm-rum';
import { getEnv } from 'helper/window-helper';
import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { HeaderProvider } from 'data/context/header-context';
import { Headers } from 'components/header/headers-component';
import { AlertProvider } from 'data/context/alert-context';
import { AlertModalProvider } from 'data/context/alert-modal-context';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

const apm = initApm({
  // Set required service name (allowed characters: a-z, A-Z, 0-9, -, _, and space)
  serviceName: 'is-compras-web',

  // Set custom APM Server URL (default: http://localhost:8200)
  serverUrl: 'https://apm.prd.lumeprodutos.com.br/',

  // Set service version (required for sourcemap feature)
  serviceVersion: '1.0.0',

  environment: getEnv('REACT_APP_SERVER_ENVIRONMENT'),

  distributedTracingOrigins: ['https://iscompras.dev.lumeprodutos.com.br', 'https://is-services.api.intelligentsupply.com.br'],

  propagateTracestate: true,
});

root.render(
  <BrowserRouter>
    <AuthProvider>
      <LoaderProvider>
        <HeaderProvider>
          <ReactNotifications />
          <AlertProvider>
            <AlertModalProvider>
              <Headers />

              <Global>
                <AppRoutes />
              </Global>
            </AlertModalProvider>
          </AlertProvider>
          <ServerEnvironment />
        </HeaderProvider>
      </LoaderProvider>
    </AuthProvider>
  </BrowserRouter>
);
